import React from 'react';
import { Layout, Typography } from 'antd';
import { companyInfo } from '../data/mockData';
import Logo from './Logo';

const { Header: AntHeader } = Layout;
const { Title } = Typography;

const Header = () => {
  return (
    <AntHeader 
      style={{ 
        background: 'white',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        padding: '0 50px',
        display: 'flex',
        alignItems: 'center',
        height: '80px',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ marginRight: '15px', display: 'flex', alignItems: 'center' }}>
          <Logo size={50} />
        </div>
        <Title 
          level={3} 
          style={{ 
            margin: 0, 
            color: '#1890ff',
            fontWeight: 'bold',
            fontSize: '24px'
          }}
        >
          {companyInfo.brandName}
        </Title>
      </div>
    </AntHeader>
  );
};

export default Header;